import { useParams } from "react-router-dom";
import { CheckCircle2, Circle, Loader2 } from "lucide-react";
import { fdt, imgUrl, useApi } from "@/lib/api";
import { asMedia } from "@/components/Media";

function Build({ b, single }) {
  return (
    <div className="rounded-xl border bg-white p-5 sm:p-6 mb-5" data-testid={`track-build-${b.buildIndex}`}>
      <div className="flex items-baseline justify-between gap-3">
        <div className="font-mono font-semibold">{b.projectCode}{!single && <span className="ml-2 text-xs text-zinc-500">Build {b.buildIndex}</span>}</div>
        <div className="text-sm font-semibold text-[#d32f2f]" data-testid={`track-progress-${b.buildIndex}`}>{b.progressPct}% Completed</div>
      </div>
      <div className="h-2 rounded-full bg-zinc-100 mt-3 overflow-hidden"><div className="h-full bg-[#d32f2f] transition-[width] duration-500" style={{ width: `${b.progressPct}%` }} /></div>
      <ol className="mt-5 space-y-4">
        {b.stages.map((s, i) => (
          <li key={i} className="flex gap-3" data-testid={`track-stage-${b.buildIndex}-${i}`}>
            {s.isCompleted ? <CheckCircle2 className="h-5 w-5 text-emerald-600 shrink-0" /> : <Circle className={`h-5 w-5 shrink-0 ${s.isCurrent ? "text-[#d32f2f]" : "text-zinc-300"}`} />}
            <div className="flex-1 min-w-0">
              <div className={`text-sm ${s.isCurrent ? "font-semibold" : ""}`}>{s.isCurrent && b.status !== "COMPLETED" ? `In ${s.stageName}` : s.stageName}</div>
              <div className="text-xs text-zinc-500">{s.isCompleted ? `Completed ${fdt(s.completedAt)}` : s.isCurrent && s.dueAt ? `Expected by ${fdt(s.dueAt)}` : ""}</div>
              {s.photos.length > 0 && <div className="flex gap-2 mt-2 overflow-x-auto">{s.photos.map(asMedia).map((m, j) => (
                m.kind === "link" ? <a key={j} href={m.path} target="_blank" rel="noreferrer" className="text-xs underline self-center">View media</a>
                  : m.kind === "video" ? <video key={j} src={imgUrl(m.path)} controls className="h-24 rounded-md" />
                  : <img key={j} src={imgUrl(m.path)} alt={s.stageName} className="h-24 w-32 object-cover rounded-md border" />))}</div>}
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}

export default function TrackBuild() {
  const { token } = useParams();
  const { data, loading } = useApi(`/public/track/${token}`);
  return (
    <div className="min-h-screen bg-zinc-50 text-zinc-900 px-4 py-8">
      <div className="max-w-2xl mx-auto">
        <img src="/brand/gn-logo.png" alt="Gamerz Nation" className="h-14 mb-6" />
        {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : !data ? <div className="text-sm text-zinc-500">This tracking link is invalid.</div> : <>
          <h1 className="text-2xl font-semibold" data-testid="track-title">Hi {data.customerName}, here's your build</h1>
          <p className="text-sm text-zinc-500 mt-1 mb-6">Order <span className="font-mono" data-testid="track-order-code">{data.orderCode}</span>{data.buildCount > 1 ? ` · ${data.buildCount} systems` : ""}</p>
          {data.builds.map((b) => <Build key={b.projectCode} b={b} single={data.buildCount === 1} />)}
        </>}
      </div>
    </div>
  );
}
